// Mirrors backend/server/services/fiscal-payment-method.ts; keep both in sync.
const LABELS = {
  hr: { 'NOVČANICE': 'Novčanice', KARTICA: 'Kartica', OSTALO: 'Ostalo', ki: 'Kulturna iskaznica', and: 'i', card: 'kartica', cash: 'gotovina' },
  en: { 'NOVČANICE': 'Cash', KARTICA: 'Card', OSTALO: 'Other', ki: 'Kulturna iskaznica', and: 'and', card: 'card', cash: 'cash' },
}
const hasKi = o => o.paymentType === 'KULTURNA_ISKAZNICA' || Boolean(o.kiData && o.kiData.brojOdobrenja)
const hasGiftCardPart = o => Number(String(o.giftCardAmount || '').replace(/[^\d.]/g, '') || 0) > 0

export function resolveFiscalPaymentMethod(o) {
  if (hasKi(o) || hasGiftCardPart(o)) return 'OSTALO'
  if (!o.paymentType) return 'KARTICA'

  return { CASH: 'NOVČANICE', CARD: 'KARTICA' }[o.paymentType] || 'OSTALO'
}

export function invoicePaymentMethodLabel(order, fiscalisationInfo, lang = 'hr') {
  const t = LABELS[lang === 'en' ? 'en' : 'hr']
  const stored = fiscalisationInfo && fiscalisationInfo.full_receipt && fiscalisationInfo.full_receipt.payment_method
  const method = t[stored] ? stored : resolveFiscalPaymentMethod(order || {})
  if (method !== 'OSTALO' || !hasKi(order || {})) return t[method]
  const remainder = Number((order.kiData && order.kiData.remainderAmount) || 0) > 0

  return remainder ? `${t[method]} (${t.ki} ${t.and} ${order.paymentType === 'CASH' ? t.cash : t.card})` : `${t[method]} (${t.ki})`
}
